export const formatCurrency = (amount: number | string, decimalPlaces: number = 2): string => {
  return Number(amount).toLocaleString(undefined, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  })
}
